import * as React from "react";
import {WorkkardDetailSec2Loader} from '../../../components/SkeletonLoader';

export default function Header(props) {
    return (
        <div className="wkDetailInfo">
            {(!props.children || props.isLoading)?<WorkkardDetailSec2Loader count={2}/> : props.children}
        </div>
    );
}